import React from "react";
import { useSelector } from "react-redux";
import { TemplateQuestion } from "../../types/types";
import * as fState from "../../reducers/formReducer";
import * as cState from "../certReducer";
import FormInput from "../../components/form/FormInput";
import FormTextArea from "../../components/form/FormTextArea";
import { FormSelect } from "../../components/form/FormSelect";
import { useForm } from "react-hook-form";
import { returnRequiredRule } from "../../utils/functions";

interface TemplateFormProps {
  questions: TemplateQuestion[];
  handleInputChange: (e: any, id: string) => void;
}

export const Form = ({ questions, handleInputChange }: TemplateFormProps) => {
  const values = useSelector(fState.getNewCertTemplateFormValues);
  const { sendMultiple, personQuestionIds } = useSelector(cState.sendMultiple);
  const { register, trigger, errors } = useForm();

  function validate(id: string) {
    trigger(id);
  }

  return (
    <div className="flex flex-wrap">
      {questions.map((q) =>
        sendMultiple && q.person ? (
          <FormSelect
            divStyle="flex flex-col w-1/2"
            key={q.id}
            id={q.id}
            cursiveLabel={q.description}
            question={q.question}
            value={q.readOnly ? q.defaultValue : values[q.id] || ""}
            options={personQuestionIds}
            register={q.required ? returnRequiredRule("text", register) : null}
            validate={validate}
            errors={errors}
            handleInputChange={handleInputChange}
            disabled={q.readOnly ? true : false}
          />
        ) : q.type === "text" || q.type === "email" ? (
          <FormInput
            divStyle="flex flex-col w-1/2"
            key={q.id}
            id={q.id}
            cursiveLabel={q.description}
            question={q.question}
            type="text"
            value={q.readOnly ? q.defaultValue : values[q.id] || ""}
            register={q.required ? returnRequiredRule(q.type, register) : null}
            validate={validate}
            errors={errors}
            disabled={q.readOnly ? true : false}
            handleInputChange={handleInputChange}
          />
        ) : (
          <FormTextArea
            divStyle="flex flex-col w-full"
            inputStyle="font-semibold text-brand-dark_blue focus:outline-none focus:bg-blue-100 focus:shadow-inner border border-gray-300 rounded-lg py-2 px-4 m-4 appearance-none leading-normal cursor-pointer w-11/12"
            key={q.id}
            id={q.id}
            cursiveLabel={q.description}
            question={q.question}
            value={q.readOnly ? q.defaultValue : values[q.id] || ""}
            register={q.required ? returnRequiredRule(q.type, register) : null}
            validate={validate}
            errors={errors}
            disabled={q.readOnly ? true : false}
            handleInputChange={handleInputChange}
          />
        )
      )}
    </div>
  );
};
